import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 20px;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
  margin: 30px 0;
`;

export const List = styled.ul`
  margin-top: 20px;
  padding-left: 20px;
  list-style-type: disc;
`;

export const StyledH2 = styled.h2`
  font-size: 1.375rem;
  font-weight: 600;
  line-height: 26px;
`;

export const ListItem = styled.li`
  margin: 5px 0;
  font-size: 0.9rem;
  font-weight: ${({ theme }) => theme.typography.paragraph.fontWeight.xLarge};
  a {
    &:hover {
      text-decoration: underline;
    }
  }
`;
